import { ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RESUMO_FINANCEIRO, DETERMINAR_PAGINA_ATUAL_RESUMO_FINANCEIRO } from '../../actions/types';


export const paginaAtualResumoFinanceiro = (state = 1, action) => {
  switch (action.type) {
    case DETERMINAR_PAGINA_ATUAL_RESUMO_FINANCEIRO: {
      return action.payload;
    }

    default:
      return state;
  }
};

export const registrosPorPaginaResumoFinanceiro = (state = 50, action) => {
  switch (action.type) {
    case ALTERAR_NUMERO_REGISTROS_POR_PAGINA_RESUMO_FINANCEIRO: {
      return action.payload;
    }

    default:
      return state;
  }
};
